import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import user from './modules/user'
import company from './modules/company'
import webSocket from './modules/webSocket'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    user,
    company,
    webSocket
  },
  strict: process.env.NODE_ENV !== 'production'
})
